document.addEventListener('variant:update', (event) => {
  const html = event.detail?.data?.html;
  const productId = event.detail?.data?.productId;

  if (!html || !productId) return;

  const blockId = `VariantDimensions-${productId}`;
  const destination = document.getElementById(blockId);
  const source = html.getElementById(blockId);

  if (!destination) return;

  if (!source) {
    destination.innerHTML = '';
    destination.hidden = true;
    return;
  }

  destination.innerHTML = source.innerHTML;
  destination.hidden = source.textContent.trim() === '';
});